import { Directive } from '@angular/core';

@Directive({
  selector: '[appNgbdListSortableHeader]'
})
export class NgbdListSortableHeaderDirective {

  constructor() { }

}
